import { BookOpen, CalendarCheck, ClipboardCheck, ClipboardList, FolderDown, HelpCircle, Home, LifeBuoy, PenLine, UserRound, Video, Wallet } from 'lucide-react';
import type { NavGroup, PaletteCommand } from './types';

/** Student app: what to study, what is due, how am I doing, and fees. */
export const studentNav: readonly NavGroup[] = [
  {
    id: 'home',
    items: [
      { id: 'home', label: 'Home', to: '/student', icon: Home, end: true, tab: true, keywords: ['dashboard', 'overview'] },
      { id: 'learn', label: 'Learn', to: '/student/learn', icon: FolderDown, tab: true, keywords: ['notes', 'material', 'download', 'pdf', 'dpp', 'pyq', 'formula'] },
      { id: 'tests', label: 'Tests', to: '/student/tests', icon: ClipboardCheck, tab: true, keywords: ['marks', 'rank', 'results', 'mock', 'report card'] },
      { id: 'homework', label: 'Homework', to: '/student/homework', icon: ClipboardList, tab: true, keywords: ['assignment', 'dpp', 'due'] },
    ],
  },
  {
    id: 'classes',
    label: 'Classes',
    items: [
      { id: 'lectures', label: 'Lectures', to: '/student/lectures', icon: Video, keywords: ['live class', 'recording', 'video', 'watch', 'join'] },
      { id: 'practice', label: 'Practice', to: '/student/practice', icon: PenLine, keywords: ['quiz', 'mcq', 'test yourself', 'timed'] },
      { id: 'attendance', label: 'Attendance', to: '/student/attendance', icon: CalendarCheck, keywords: ['timetable', 'schedule', 'absent'] },
      { id: 'doubts', label: 'Doubts', to: '/student/doubts', icon: HelpCircle, keywords: ['ask', 'question', 'teacher'] },
    ],
  },
  {
    id: 'me',
    label: 'Me',
    items: [
      { id: 'pay', label: 'Pay fees', to: '/student/pay', icon: Wallet, keywords: ['fee', 'dues', 'receipts', 'upi'] },
      { id: 'profile', label: 'Profile', to: '/student/profile', icon: UserRound, keywords: ['account', 'documents'] },
      { id: 'help', label: 'Help', to: '/student/help', icon: LifeBuoy, keywords: ['support', 'contact', 'faq'] },
    ],
  },
];

export const studentCommands: readonly PaletteCommand[] = [
  { id: 'pay-now', label: 'Pay fees', to: '/student/pay', icon: Wallet, keywords: ['dues', 'upi'] },
  { id: 'ask-doubt', label: 'Ask a doubt', to: '/student/doubts', icon: HelpCircle, keywords: ['question', 'teacher'] },
  { id: 'download-notes', label: 'Download study material', to: '/student/learn', icon: BookOpen, keywords: ['notes', 'pdf'] },
];
